<template>
  <div>
    <el-form :inline="true">
      <el-form-item>
        <el-select
          placeholder="产品"
          v-model="searchForm.product_id"
          size="small"
          clearable
          filterable
        >
          <el-option
            v-for="item in productList"
            :key="item.id"
            :label="`${item.product_name}${item.product_size}(${item.customer_name})`"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select
          placeholder="材质"
          v-model="searchForm.material_name"
          size="small"
          clearable
          filterable
        >
          <el-option
            v-for="(item,index) in $store.state.materialNameList"
            :key="index"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select
          placeholder="规格"
          v-model="searchForm.material_size"
          size="small"
          clearable
          filterable
        >
          <el-option
            v-for="(item,index) in $store.state.materialSizeList"
            :key="index"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="searchForm.page = 1;getList()"
        >搜索</el-button>
      </el-form-item>
    </el-form>
    <el-row style="margin-bottom:15px">
      <el-button size="small" type="success" @click="addMaterialVisible = true">添加原料</el-button>
      <CreateBuyOrderButton :selectList="selectList" />
      <el-button style="float:right" size="small" icon="el-icon-download" v-show="false">另存为Excel</el-button>
    </el-row>
    <el-alert type="success" :closable="false" style="margin-bottom:15px">
      <div slot="title">
        <span style="line-height:35px">已选产品:</span>
        <span v-if="selectList.length === 0">无</span>
        <span v-else>
          <el-tag
            @close="$refs.materialTable.toggleRowSelection(item)"
            closable
            type="success"
            style="margin-right:10px"
            v-for="(item, index) in selectList"
            :key="item.id"
          >{{` ${index+1}、${item.material_name}(${item.material_size}) `}}</el-tag>
          <el-tag
            type="primary"
            style="margin-right:10px;cursor:pointer"
            @click="$refs['materialTable'].clearSelection()"
          >清空</el-tag>
        </span>
      </div>
    </el-alert>
    <el-table
      ref="materialTable"
      :data="materialTableData"
      :border="true"
      :highlight-current-row="true"
      v-loading="materialTableLoading"
      @sort-change="sortChange"
      @selection-change="(selection)=>{selectList=selection}"
      @row-click="row=>{$refs.materialTable.toggleRowSelection(row)}"
      :row-key="row=>row.id"
    >
      <el-table-column :reserve-selection="true" type="selection" align="center"></el-table-column>
      <!-- <el-table-column prop="supplier" label="供应商名称" align="center"></el-table-column> -->
      <el-table-column prop="material_name" label="材质" align="center"></el-table-column>
      <el-table-column
        prop="material_size"
        label="规格"
        align="center"
        sortable="custom"
        width="200px"
      >
        <template slot-scope="scope">
          <span v-for="(sizeNumber,idx) in scope.row.material_size.split('*')" :key="idx">
            <span v-if="sizeNumber!==''">
              <span
                v-if="sizeNumber.indexOf('/')===-1"
                style="display:inline-block"
              >{{sizeNumber.replace('@','↧').replace('^','φ')}}</span>
              <span style="display:inline-block" v-else>
                <span
                  style="display:inline-block;text-align:right"
                >{{sizeNumber.split(/[+|-]/)[0].replace('@','↧').replace('^','φ')}}</span>
                <span style="position:relative;width:32px;display:inline-block">
                  <sup
                    style="position:absolute;left:0px;bottom:5px;width:40px;display:inline-block;line-height:10px;text-align:left"
                  >{{sizeNumber.match(/[+|-]/)[0]+sizeNumber.split(/[+|-]/)[1].split('/')[0]}}</sup>
                  <sub
                    style="position:absolute;left:2px;top:-5px;width:40px;display:inline-block;line-height:10px;text-align:left"
                  >{{sizeNumber.match(/\/(.)/)[1]+sizeNumber.split(/[+|-]/)[2]}}</sub>
                </span>
              </span>
              <span v-if="idx+1 !== scope.row.material_size.split('*').length">*</span>
            </span>
          </span>
        </template>
      </el-table-column>
      <el-table-column label="关联产品" align="center">
        <template slot-scope="scope">
          <div
            v-if="scope.row.product_id"
          >{{`${scope.row.product_name} ${scope.row.product_size} (${scope.row.customer_name})`}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" align="center"></el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="110px">
        <template slot-scope="scope">
          <el-link type="primary" @click.stop="showEdit(scope.row)">编辑</el-link>
          <el-divider direction="vertical"></el-divider>
          <el-popconfirm
            confirmButtonText="确认"
            cancelButtonText="取消"
            icon="el-icon-warning-outline"
            iconColor="red"
            title="确定删除吗？"
            @click.native="(e)=>{e.stopPropagation()}"
            @onConfirm="deleteMaterial(scope.row.id)"
          >
            <el-link slot="reference" type="primary">删除</el-link>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="margin-top:15px"
      :total="materialTableTotal"
      :current-page.sync="searchForm.page"
      @current-change="(page)=>{this.searchForm.page = page;this.getList()}"
      @size-change="(size)=>{this.searchForm.pageSize = size;this.searchForm.page = 1;this.getList()}"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="10"
      layout="prev, pager, next, ->, total, sizes"
      align="center"
    ></el-pagination>
    <!-- 添加对话框 -->
    <el-dialog
      title="添加原料"
      :visible.sync="addMaterialVisible"
      width="700px"
      @close="$refs.addForm.resetFields()"
      :close-on-click-modal="false"
    >
      <el-form ref="addForm" :model="addForm" label-width="250px">
        <!-- <el-form-item prop="supplier" label="供应商名称">
          <el-select placeholder="供应商" v-model="addForm.supplier" size="small" clearable filterable>
            <el-option
              v-for="(item,index) in $store.state.supplierList"
              :key="index"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>-->
        <el-form-item
          prop="material_name"
          label="材质"
          :rules="{required: true, message: '材质不能为空', trigger:'change'}"
        >
          <el-autocomplete
            size="small"
            v-model="addForm.material_name"
            :fetch-suggestions="(query,cb)=>{cb(query ? this.$store.state.materialNameList.map(ele=>{ return {value:ele}}).filter((item)=> (item.value.indexOf(query) !== -1)) : this.$store.state.materialNameList.map(ele=>{return {value: ele}}))}"
            placeholder="材质"
            :clearable="true"
            style="width:200px"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item prop="material_size" label="规格">
          <el-autocomplete
            size="small"
            v-model="addForm.material_size"
            :fetch-suggestions="(query,cb)=>{cb(query ? this.$store.state.materialSizeList.map(ele=>{ return {value:ele}}).filter((item)=> (item.value.indexOf(query) !== -1)) : this.$store.state.materialSizeList.map(ele=>{return {value: ele}}))}"
            placeholder="规格"
            :clearable="true"
            style="width:200px"
          ></el-autocomplete>
          <el-alert
            class="materia-dialog-alert"
            style="height:20px;width:370px;margin-top:5px"
            type="info"
            :closable="false"
            title="①误差录入规则:+0.01/-0.02 ②字符替代规则:@=>↧，^=>φ"
          ></el-alert>
        </el-form-item>
        <el-form-item prop="product_id" label="关联产品">
          <el-select
            placeholder="请选择产品"
            v-model="addForm.product_id"
            size="small"
            clearable
            filterable
          >
            <el-option
              v-for="item in productList"
              :key="item.id"
              :label="`${item.product_name}${item.product_size}(${item.customer_name})`"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="remark" label="备注">
          <el-input
            size="small"
            v-model="addForm.remark"
            placeholder="备注"
            style="width:200px"
            :clearable="true"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="addMaterialVisible=false">取消</el-button>
        <el-button size="small" type="primary" @click="addMaterial">确认</el-button>
      </span>
    </el-dialog>
    <!-- 编辑对话框 -->
    <el-dialog
      :title="`编辑 (${current.material_name} ${current.material_size})`"
      :visible.sync="editMaterialVisible"
      width="700px"
      @close="$refs.editForm.resetFields()"
      :close-on-click-modal="false"
    >
      <el-form ref="editForm" :model="editForm" label-width="250px">
        <!-- <el-form-item prop="supplier" label="供应商名称">
          <el-select
            placeholder="供应商"
            v-model="editForm.supplier"
            size="small"
            clearable
            filterable
          >
            <el-option
              v-for="(item,index) in $store.state.supplierList"
              :key="index"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>-->
        <el-form-item
          prop="material_name"
          label="材质"
          :rules="{required: true, message: '材质不能为空', trigger:'change'}"
        >
          <el-autocomplete
            size="small"
            v-model="editForm.material_name"
            :fetch-suggestions="(query,cb)=>{cb(query ? this.$store.state.materialNameList.map(ele=>{ return {value:ele}}).filter((item)=> (item.value.indexOf(query) !== -1)) : this.$store.state.materialNameList.map(ele=>{return {value: ele}}))}"
            placeholder="材质"
            :clearable="true"
            style="width:200px"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item prop="material_size" label="规格">
          <el-autocomplete
            size="small"
            v-model="editForm.material_size"
            :fetch-suggestions="(query,cb)=>{cb(query ? this.$store.state.materialSizeList.map(ele=>{ return {value:ele}}).filter((item)=> (item.value.indexOf(query) !== -1)) : this.$store.state.materialSizeList.map(ele=>{return {value: ele}}))}"
            placeholder="规格"
            :clearable="true"
            style="width:200px"
          ></el-autocomplete>
          <el-alert
            class="materia-dialog-alert"
            style="height:20px;width:370px;margin-top:5px"
            type="info"
            :closable="false"
            title="①误差录入规则:+0.01/-0.02 ②字符替代规则:@=>↧，^=>φ"
          ></el-alert>
        </el-form-item>
        <el-form-item prop="product_id" label="关联产品">
          <el-select
            placeholder="请选择产品"
            v-model="editForm.product_id"
            size="small"
            clearable
            filterable
          >
            <el-option
              v-for="item in productList"
              :key="item.id"
              :label="`${item.product_name}${item.product_size}(${item.customer_name})`"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="remark" label="备注">
          <el-input
            size="small"
            v-model="editForm.remark"
            placeholder="备注"
            style="width:200px"
            :clearable="true"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="editMaterialVisible=false">取消</el-button>
        <el-button size="small" type="primary" @click="editMaterial">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getMaterialList, addMaterial, editMaterial, deleteMaterial, getProductSelectList } from '../api/index'
import CreateBuyOrderButton from '../components/CreateBuyOrderButton'
export default {
  name: 'materialList',
  components: {
    CreateBuyOrderButton
  },
  data () {
    return {
      // 产品列表
      materialTableLoading: false,
      searchForm: {
        product_id: '',
        material_name: '',
        material_size: '',
        sortType: 'id',
        order: 'desc',
        page: 1,
        pageSize: 10
      },
      materialTableTotal: null,
      materialTableData: [],
      selectList: [],
      productList: [],
      // 添加原料
      addMaterialVisible: false,
      addForm: {
        // supplier: '',
        material_name: '',
        material_size: '',
        product_id: '',
        remark: ''
      },
      // 选中项信息
      current: {},
      // 编辑原料
      editMaterialVisible: false,
      editForm: {
        id: '',
        // supplier: '',
        material_name: '',
        material_size: '',
        product_id: '',
        remark: ''
      }
    }
  },
  mounted () {
    this.getList()
    this.getProductSelectList()
  },
  methods: {
    getProductSelectList () {
      getProductSelectList().then(res => {
        if (res.data.status === 200) {
          this.productList = res.data.data
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    sortChange (sortInfo) {
      this.searchForm.sortType = sortInfo.prop
      if (sortInfo.order === 'ascending') {
        this.searchForm.order = 'asc'
      } else if (sortInfo.order === 'descending') {
        this.searchForm.order = 'desc'
      } else {
        this.searchForm.sortType = 'id'
        this.searchForm.order = 'desc'
      }
      this.searchForm.page = 1
      this.getList()
    },
    deleteMaterial (id) {
      deleteMaterial({ id }).then(res => {
        if (res.data.status === 200) {
          this.$message.success(res.data.msg)
          this.getList()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    editMaterial () {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          editMaterial(this.editForm).then(res => {
            if (res.data.status === 200) {
              this.$message.success(res.data.msg)
              this.$refs.editForm.resetFields()
              this.getList()
              this.editMaterialVisible = false
            } else {
              this.$message.error(res.data.msg)
            }
          })
        }
      })
    },
    showEdit (current) {
      this.editForm = JSON.parse(JSON.stringify(current))
      this.current = current
      this.editMaterialVisible = true
    },
    addMaterial () {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          addMaterial(this.addForm).then(res => {
            if (res.data.status === 200) {
              this.$message.success(res.data.msg)
              this.$refs.addForm.resetFields()
              this.getList()
              this.addMaterialVisible = false
              this.$store.dispatch('getLoginInfo')
            } else {
              this.$message.error(res.data.msg)
            }
          })
        }
      })
    },
    getList () {
      this.materialTableLoading = true
      getMaterialList(this.searchForm).then(res => {
        // console.log(res)
        if (res.data.status === 200) {
          this.materialTableData = res.data.data
          this.materialTableTotal = res.data.total
          this.materialTableLoading = false
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }
  }
}
</script>

<style>
.materia-dialog-alert .el-alert__title{
  font-size: 12px;
}
</style>
